module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "textcenter"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("You have navigated with raging soul far from the paternal home, passing beyond the seas’ double rocks and now you inhabit a foreign land.")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_c('em', [_vm._v("Medea")]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56a4d665","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm06.vue
// module id = 78
// module chunks = 0